if (typeof Shopify === 'undefined' || !Shopify.designMode) {
    
  window.addEventListener('load', () => {
    
    let cancel_redirect = document.getElementById("cancel_redirect");
    let popRedirect = document.getElementById('cont_modal_redirect_api');
    let countryActual = document.getElementById('text_country');
    let urlRedirect = document.getElementById('a_cta_pop_redirect');
    let contPage = document.getElementById("main-container-pages");

    function isModalRedirectDisabled() {
      const chrome = document.querySelector(
        '[data-landing-chrome][data-hide-modal-redirect="true"]'
      );
      return Boolean(chrome);
    }

    if (!cancel_redirect || !popRedirect || !contPage) return;
    if (isModalRedirectDisabled()) {
      popRedirect.style.display = "none";
      contPage.style.overflow = "";
      return;
    }

    const userAgent = navigator.userAgent.toLowerCase();
    const isBot = /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot/.test(userAgent);
     
  
    cancel_redirect.addEventListener('click', (event) => {
      popRedirect.style.display = "none";   
      contPage.style.overflow = "auto";   
    });
    
    if (!isBot){
      if(!localStorage.getItem("countryCodMalva") || localStorage.getItem("countryCodMalva") == "undefined"){
        //fetch(`https://ipinfo.io/json?token=18d83ea49777e0`)
        let ipClient = "";
        fetch(`https://api.ipify.org`)
        .then(response => response.text())
        .then(data => {
          ipClient = data;
          fetch(`https://api.ipinfo.io/lite/${ipClient}?token=190233c9aaece1`)         
          .then(response => response.json())
          .then(data => {
            localStorage.setItem("countryCodMalva", data.country_code)
            localStorage.setItem("countryNameMalva", data.country)
            validacionPais(localStorage.getItem("countryCodMalva"), localStorage.getItem("countryNameMalva"));
          }).catch(error => {
            console.error('Error al obtener la información de geolocalización:', error);
          });  
        }); 
        
         
      }else{      
        validacionPais(localStorage.getItem("countryCodMalva"), localStorage.getItem("countryNameMalva"));
      }
    }
    
    function validacionPais (contry_code, contry_name){
      if (isModalRedirectDisabled()) {
        popRedirect.style.display = "none";
        contPage.style.overflow = "";
        return;
      }

      if (contry_code === "CO"){  
        popRedirect.style.display = "flex";
        contPage.style.overflow = "hidden";
          urlRedirect.href = "https://co.malvaonline.com/";  
        countryActual.innerText = contry_name;  
      }else if(contry_code === "PE"){
        popRedirect.style.display = "flex";
        contPage.style.overflow = "hidden";
          urlRedirect.href = "https://pe.malvaonline.com/";
        countryActual.innerText = contry_name;
      }
    }

  });
}
